export default {
  alternativeController: {
    id: 'product_page_carousel_alternative_controller',
    defaultMessage: 'Controller',
  },
  alternativeNext: {
    id: 'product_page_carousel_alternative_next',
    defaultMessage: 'Next',
  },
  alternativePrevious: {
    id: 'product_page_carousel_alternative_previous',
    defaultMessage: 'Previous',
  },
  alternativeClose: {
    id: 'product_page_carousel_alternative_close',
    defaultMessage: 'Close',
  },
  imageCarousel1: {
    id: 'product_page_iphone17_carousel_image_1',
    defaultMessage: 'Template image 1',
  },
  imageCarousel2: {
    id: 'product_page_iphone17_carousel_image_2',
    defaultMessage: 'Template image 2',
  },
  imageCarousel3: {
    id: 'product_page_iphone17_carousel_image_3',
    defaultMessage: 'Template image 3',
  },
  imageCarousel4: {
    id: 'product_page_iphone17_carousel_image_4',
    defaultMessage: 'Template image 4',
  },
  imageCarousel5: {
    id: 'product_page_iphone17_carousel_image_5',
    defaultMessage: 'Template image 5',
  },
}
